<template>
  <media-query-provider :queries="{ mobile: '(max-width: 680px)' }">
    <router-view />
  </media-query-provider>
</template>

<script>
import { MediaQueryProvider } from 'vue-component-media-queries'
import { mapState } from 'vuex'
import { modulesName } from '@/store'
import loading from '@/mixins/vue-loading'

export default {
  name: 'App',
  components: { MediaQueryProvider },
  mixins: [loading],
  computed: {
    ...mapState(modulesName.appModuleName, ['loading']),
  },
  watch: {
    loading: {
      immediate: true,
      handler(val) {
        val === true ? this.ShowWait() : this.HideWait()
      },
    },
  },
  created() {
    if (
      window.location.protocol !== 'https:' &&
      window.location.href.indexOf('localhost') < 0
    ) {
      window.location.replace(window.location.href.replace('http:', 'https:'))
    }
  },
}
</script>
